import { c as _c } from "react/compiler-runtime";
import { useIdentityContext } from '@cc-shopping/platform-analytics/IdentityContext';
import { Box, Skeleton, Typography } from '@mui/material';
import type { ApprovalOddsAnalytics, Odds } from 'src/features/approval-odds';
import { ApprovalOddsButton } from 'src/features/approval-odds/ApprovalOddsButton';
import { useUserCreditScore } from 'src/features/approval-odds/hooks';
import { getOddsLabel } from 'src/features/approval-odds/utils';
type RecommendedCreditScoreProps = {
  analytics?: ApprovalOddsAnalytics;
  odds: Odds;
  hasLimitedCreditHistory?: boolean;
  hideOddsButton?: boolean;
  hideTooltip?: boolean;
  firePageActionOnClick?: boolean;
  isAmexOffer?: boolean;
};
export const RecommendedCreditScore = t0 => {
  const $ = _c(22);
  const {
    analytics,
    firePageActionOnClick: t1,
    hideOddsButton: t2,
    hideTooltip: t3,
    odds,
    isAmexOffer
  } = t0;
  const firePageActionOnClick = t1 === undefined ? false : t1;
  const hideOddsButton = t2 === undefined ? false : t2;
  const hideTooltip = t3 === undefined ? false : t3;
  const {
    identity,
    isLoading
  } = useIdentityContext();
  let t4;
  if ($[0] !== identity || $[1] !== odds) {
    t4 = {
      identity,
      odds
    };
    $[0] = identity;
    $[1] = odds;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const {
    userCreditScore
  } = useUserCreditScore(t4);
  let t5;
  if ($[3] !== isAmexOffer || $[4] !== odds.max || $[5] !== odds.min) {
    t5 = isAmexOffer ? getOddsLabel(odds.min, odds.max) : `${odds.min}-${odds.max} (${getOddsLabel(odds.min, odds.max)})`;
    $[3] = isAmexOffer;
    $[4] = odds.max;
    $[5] = odds.min;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const label = t5;
  const creditScore = identity?.creditScore;
  if (isLoading) {
    let t6;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <Skeleton height={60} width="75%" />;
      $[7] = t6;
    } else {
      t6 = $[7];
    }
    return t6;
  }
  let t6;
  if ($[8] !== label) {
    t6 = <Typography variant="text">{label}</Typography>;
    $[8] = label;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== analytics || $[11] !== firePageActionOnClick || $[12] !== hideOddsButton || $[13] !== hideTooltip || $[14] !== userCreditScore) {
    t7 = !userCreditScore && !hideOddsButton && <ApprovalOddsButton analytics={analytics} hideTooltip={hideTooltip} firePageActionOnClick={firePageActionOnClick} />;
    $[10] = analytics;
    $[11] = firePageActionOnClick;
    $[12] = hideOddsButton;
    $[13] = hideTooltip;
    $[14] = userCreditScore;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== creditScore) {
    t8 = creditScore && <Typography marginTop="0.25rem" display="block" variant="textSmall">(Your score: {creditScore})</Typography>;
    $[16] = creditScore;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
    t9 = <Box display="flex" flexDirection="column" rowGap={1}>{t6}{t7}{t8}</Box>;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
};